import dynamic from 'next/dynamic'
import { Component } from 'react'

/**
 * For some reasons Next.js build Class Component in a different way and importing components here
 * that use cx from @emotion/css causes gtm preview to break
 * @see https://filoblu.atlassian.net/browse/BLUMAIN-125
 */
const ErrorLayout = dynamic(() => import('@bluheadless/ui/src/layouts/error-layout/error-layout'), { ssr: false })
const ErrorPageComponent = dynamic(() => import('@bluheadless/ui/src/page-components/error/error'), { ssr: false })

class ErrorBoundary extends Component {
	constructor(props) {
		super(props)

		// Define a state variable to track whether is an error or not
		this.state = { hasError: false, resetKey: props.resetKey }
	}
	static getDerivedStateFromError(/* error */) {
		// Update state so the next render will show the fallback UI

		return { hasError: true }
	}
	componentDidCatch(/* error, errorInfo */) {
		// You can use your own error logging service here
		//console.log({ error, errorInfo })
	}
	static getDerivedStateFromProps(nextProps, prevState) {
		if (nextProps.resetKey !== prevState.resetKey) {
			return { hasError: false, resetKey: nextProps.resetKey }
		} else {
			return { resetKey: nextProps.resetKey }
		}
	}
	render() {
		// Check if the error is thrown
		if (this.state.hasError) {
			// You can render any custom fallback UI
			return (
				<ErrorLayout>
					<ErrorPageComponent />
				</ErrorLayout>
			)
		}

		// Return children components in case of no error

		return this.props.children
	}
}

export default ErrorBoundary
